export default __webpack_public_path__ + "static/2-c2ca7f7454f6988530093d0ae9ed791a.png";